// Ported from cartadigital-pos app/domain/pricing/rounding.ts — keep in
// behavioral parity with backend `applyRound()`.
import { RoundMode } from '@/enums/RoundMode';
import { roundPrice } from '@/utils';

/**
 * Ported from `cartadigital-api/src/utilities/functions.ts` `applyRound()`.
 *
 * Applies rounding interval AFTER base total rounding (2 decimals),
 * matching backend behavior.
 */
export function applyRound(
  val: number,
  mode: RoundMode,
  interval: number
): number {
  if (mode === RoundMode.None) return val;
  if (!Number.isFinite(interval) || interval <= 0) return val;
  if (!Number.isFinite(val)) return val;

  let amount = val / interval;

  switch (mode) {
    case RoundMode.Nearest:
      amount = Math.round(amount);
      break;
    case RoundMode.Floor:
      amount = Math.floor(amount);
      break;
    case RoundMode.Ceil:
      amount = Math.ceil(amount);
      break;
    default:
      return val;
  }

  return roundPrice(amount * interval);
}
